<mat-card>
    <mat-card-content>
        <div *ngIf="form && detailInfo">
            <div class="row"  [formGroup]="form">
                <div class="col-sm-3" style="padding: 0px;">
                    <div class="header-class">
                        Facture
                    </div>
                    <div class="data-class row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>N° pièce</mat-label>
                                <input matInput required name="nth-num-bp" formControlName="code" />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field matTooltip="Statut du BP"  class="full-width">
                                <mat-label>Statut</mat-label>
                                <input matInput required name="nth-libelle-bc" formControlName="status" />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Date pièce</mat-label>
                                <input matInput [matDatepicker]="pickerD" required name="nth-date-bp"
                                    formControlName="dBp">
                                <mat-datepicker-toggle matSuffix [for]="pickerD"></mat-datepicker-toggle>
                                <mat-datepicker #pickerD></mat-datepicker>
                            </mat-form-field>
                        </div>
                        
                        <div class="col-sm-12">
                            <app-autocomplete-with-code-libelle-form name="siteLib" [parent]="form" libelle="Site"
                            codeControlName="codeSite" libelleControlName="libelleSite" [objets]="detailInfo.sites">
                            </app-autocomplete-with-code-libelle-form>
                        </div>
                        <div class="col-sm-12">
                            <app-autocomplete-with-code-libelle-form name="ca1Lib" [parent]="form" libelle="CA1"
                                    codeControlName="codeCa1" libelleControlName="libelleCa1" [objets]="detailInfo.ca1s">
                            </app-autocomplete-with-code-libelle-form>
                        </div>
                        <div class="col-sm-12" >
                            <mat-form-field class="full-width">
                                <mat-label>Motif</mat-label>
                                <input matInput name="nth-ref-motif" formControlName="motif">
                                <mat-error *ngIf="form.get('motif').hasError('maxlength')">
                                    Nombre maximum de caractère dépassé.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" style="padding: 0px;">
                    <div class="header-class">
                    Fournisseur
                    </div>
                    <div class="data-class row">        
                        <div class="col-sm-12" >
                            <mat-form-field class="full-width">
                                <mat-label>Réf. fournisseur</mat-label>
                                <input matInput name="nth-ref-fourn" formControlName="refFourn">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Date de reglement</mat-label>
                                <input required matInput [matDatepicker]="pickerDRegl" name="nth-date-reg"
                                        formControlName="dRegl"
                                        [ngClass]="{'orangeBack': getStyle('dRegl','')}">
                                <mat-datepicker-toggle matSuffix [for]="pickerDRegl"></mat-datepicker-toggle>
                                <mat-datepicker #pickerDRegl></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <app-autocomplete-with-code-libelle-form name="fournisseurLib" [parent]="form"
                                    libelle="Fournisseur" [objets]="detailInfo.fournisseurs"
                                    codeControlName="codeFourn" libelleControlName="libelleFourn" 
                                    [styles]="getStyle('codeFourn','libelleFourn')">
                            </app-autocomplete-with-code-libelle-form>
                        </div>
                        <div class="col-sm-12">
                            <app-autocomplete-with-code-libelle-form name="libelleCondRegl" 
                                    [parent]="form" articlePrefix="la " libelle="Condition de règlement" 
                                    [objets]="detailInfo.condRegls" codeControlName="codeCondRegl" 
                                    libelleControlName="libelleCondRegl"
                                    [styles]="getStyle('codeCondRegl','libelleCondRegl')"> 
                            </app-autocomplete-with-code-libelle-form>
                        </div> 
                        <div class="col-sm-12">
                            <app-autocomplete-with-code-libelle-form name="libelleModeRegl" [parent]="form"
                                    libelle="Mode de règlement" [objets]="detailInfo.modeRegls"
                                    codeControlName="codeModeRegl" libelleControlName="libelleModeRegl"
                                    [styles]="getStyle('codeModeRegl','libelleModeRegl')">
                            </app-autocomplete-with-code-libelle-form>
                        </div> 
                    </div>
                </div>
                <div class="col-sm-4" style="padding: 0px;">
                    <div class="header-class">
                        Facture
                    </div>
                    <div class="data-class row">
                        <div class="col-sm-6" style="padding: 0px;">
                            <div class="row" style="margin: 0px;">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>N° de facture</mat-label>
                                            <input matInput required name="nth-ref-mention" formControlName="numFacture">
                                            <mat-error>
                                                Veuillez saisir le numéro de la facture
                                            </mat-error>
                                        </mat-form-field>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Date de facture</mat-label>
                                            <input required matInput [matDatepicker]="pickerdFacture" name="nth-date-facture-bp"
                                                    formControlName="dFacture">
                                                <mat-datepicker-toggle matSuffix [for]="pickerdFacture"></mat-datepicker-toggle>
                                                <mat-datepicker #pickerdFacture></mat-datepicker>
                                                <mat-error>
                                                    Veuillez saisir la date de la facture
                                                </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Montant TTC Facture</mat-label>
                                        <input matInput required name="nth-num-b" type="number" formControlName="montantFacture" />
                                        <mat-error *ngIf="form.get('montantFacture').hasError('required')">
                                            Veuillez saisir le montant ttc de la facture
                                        </mat-error>
                                        <mat-error *ngIf="form.get('montantFacture').hasError('different')">
                                            Veuillez saisir un montant égal au total TTC
                                        </mat-error>
                                    </mat-form-field>
                                    
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Numéro Esker</mat-label>
                                        <input matInput name="nth-num-esker" formControlName="ruidEsker" />
                                    </mat-form-field>
                                    
                                </div>
                                <div class="col-sm-12" *ngIf="VISUALISATION">
                                    <mat-form-field class="full-width" matTooltip="Date de récéption de la facture">
                                        <mat-label >Date récéption facture</mat-label>
                                        <input required matInput [matDatepicker]="pickerDCreation" name="nth-date-creation"
                                                formControlName="dCreation">
                                        <mat-datepicker-toggle matSuffix [for]="pickerDCreation"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerDCreation></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-sm-6" style="padding-left: 0px;">
                            <mat-form-field class="full-width" [matTooltip]="form.get('commentaires').value">
                                <mat-label style="margin-left: 5px; ">Observation</mat-label>
                                <textarea matInput name="nth-ref-obs" cdkTextareaAutosize [cdkAutosizeMinRows]="minRows"
                                            cdkAutosizeMaxRows="10" style="background-color: white;" 
                                            formControlName="commentaires"></textarea>
                                            <mat-error *ngIf="form.get('commentaires').hasError('maxlength')">
                                                Nombre maximum de caractère dépassé.
                                            </mat-error>
                            </mat-form-field>
                            <div class="col-sm-12" *ngIf="VISUALISATION">
                                <mat-form-field class="full-width" *ngIf="VISUALISATION" matTooltip="Date d'envoi de la facture à SAGE">
                                    <mat-label >Date d'envoi à SAGE</mat-label>
                                    <input required matInput [matDatepicker]="pickerDProvis" name="nth-date-provis" [value]="dDProvis" disabled>
                                    <mat-datepicker-toggle matSuffix [for]="pickerDProvis"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerDProvis></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12" *ngIf="VISUALISATION && form.get('status').value === 'Clos'">
                                <mat-form-field class="full-width" matTooltip="Date de paiement de la facture">
                                    <mat-label>Date de paiement</mat-label>
                                    <input required matInput [matDatepicker]="pickerDPaiement" name="nth-date-paiement" formControlName="dModification" >
                                    <mat-datepicker-toggle matSuffix [for]="pickerDPaiement"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerDPaiement></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-sm-2" id="totaux">
                    <div class="header-class">
                        Totaux
                    </div>
                    <div class="data-class row" >
                        <table>
                            <caption></caption>
                            <th></th>
                            <tbody>
                                <tr>
                                    <td class="align-cell-left"> Total HT :</td>

                                    <td class="align-cell-right" *ngIf="!amountHT || amountHT.toFixed(2).toString() === '0' ; else getHtNull"> 
                                        {{'0' | currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    <ng-template #getHtNull>
                                        <td class="align-cell-right"> 
                                            {{amountHT.toFixed(2).toString() | currency:'EUR':'symbol':'1.2-2':'fr'}}
                                        </td>
                                    </ng-template>
                                </tr> 
                                <tr>
                                    <td class="align-cell-left">Total TVA : </td>
                                    <td class="align-cell-right" *ngIf="!amountTVA || amountTVA.toFixed(2).toString() === '0' ; else getTvaNull"> 
                                        {{'0' | currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    <ng-template #getTvaNull>
                                        <td class="align-cell-right">
                                            {{amountTVA.toFixed(2).toString() | currency:'EUR':'symbol':'1.2-2':'fr'}}
                                        </td>
                                    </ng-template>
                                </tr>
                                <tr>
                                    <td class="align-cell-left">Total TTC : </td>
                                    <td class="align-cell-right" *ngIf=" !amountTTC || amountTTC.toFixed(2).toString() === '0' ; else getTtcNull"> 
                                        {{'0' | currency:'EUR':'symbol':'1.2-2':'fr'}}</td>
                                    <ng-template #getTtcNull>
                                        <td class="align-cell-right">
                                            {{amountTTC.toFixed(2).toString() | currency:'EUR':'symbol':'1.2-2':'fr'}}
                                        </td>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col-sm-4" *ngIf="showDocuments">
                            <button type="button" mat-raised-button (click)="showBcDocuments()" matTooltip="Lister les documents">
                                <mat-icon>description_outline</mat-icon>
                            </button>
                        </div>
                        <div class="col-sm-4" *ngIf="router.url.includes('/create-bp')">
                            <button type="button" mat-raised-button (click)="showAddDocument()" matTooltip="Ajouter un document">
                                <mat-icon>note_add</mat-icon>
                            </button>
                        </div>
                        <div class="col-sm-4" *ngIf="router.url.includes('/create-bp')">
                            <button type="button" mat-raised-button (click)="showAddDriveDocument()" matTooltip="Ajouter un document depuis Google Drive">
                                <mat-icon>cloud_download</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>